import React from 'react';
import { Route, Redirect } from "react-router-dom";


const PrivateRoute = ({ component: Component, ...rest }) => {

    let isLoggedIn = false;

    if (sessionStorage.getItem('authorized')) {
        let loginData= JSON.parse(sessionStorage.getItem('authorized'));
        if(loginData.success){
            isLoggedIn=true
        }
    }
    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn === true ? (
                    <Component {...props} />
                ) : (
                        <Redirect to={{ pathname: '/login' }} />
                    )
            }
        />)
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/PrivateRoute.js